import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase } from 'react-icons/fa';

const experiences = [
  {
    title: 'Web Developer',
    company: 'Unnati Informatics LLP',
    location: 'Gujarat, IN',
    period: 'Dec 2022 – Nov 2023',
    achievements: [
      'Developed 5+ responsive websites with HTML5, CSS3, and JavaScript',
      'Built Expense Tracker app with 95% Lighthouse score',
      'Improved client satisfaction by 30% with WordPress themes'
    ]
  },
  {
    title: 'Frontend Developer Intern',
    company: 'Vnurture Technologies',
    location: 'Gujarat, IN',
    period: 'Jul 2022 - Dec 2022',
    achievements: [
      'Created Time Tracking SaaS dashboard with React.js',
      'Reduced onboarding time by 25% through UI/UX',
      'Optimized 3+ WordPress sites for 15% traffic increase'
    ]
  }
];

const Experience = () => {
  return (
    <section id="experience" className="py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Professional Experience
        </h2>
        <div className="space-y-10">
          {experiences.map((exp, index) => (
            <motion.div
              key={exp.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="relative bg-gradient-to-br from-gray-800 to-gray-700 border border-gray-600 p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all"
            >
              <div className="absolute -top-6 left-6 bg-blue-500 p-2 rounded-full shadow-lg">
                <FaBriefcase className="text-white text-xl" />
              </div>
              <div className="pl-12">
                <h3 className="text-2xl font-bold text-blue-400">{exp.title}</h3>
                <p className="text-lg text-gray-300">{exp.company} - {exp.location}</p>
                <p className="text-sm text-gray-400 mb-4">{exp.period}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-200">
                  {exp.achievements.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
